import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import Logout from '../../components/Logout';
import './AdminCenter.css';

const API_BASE = 'https://crtapp.xyz';

const AdminCenter = () => {
  const navigate = useNavigate();

  const [loggedInUser, setLoggedInUser] = useState(null);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('factory');

  const [regMessage, setRegMessage] = useState('');
  const [regError, setRegError] = useState('');

  const [users, setUsers] = useState([]);
  const [delMessage, setDelMessage] = useState('');
  const [delError, setDelError] = useState('');

  const fetchUsers = useCallback(async () => {
    setDelError('');

    try {
      const response = await fetch(`${API_BASE}/api/admin/users`, {
        credentials: 'include'
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to load users');
      }

      setUsers(data.users || []);
    } catch (err) {
      console.error(err);
      setDelError('Could not load users. Please try again.');
    }
  }, []);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(`${API_BASE}/api/check-auth`, {
          credentials: 'include'
        });

        const data = await response.json();

        if (!response.ok || data.role !== 'team_lead') {
          navigate('/factory');
          return;
        }

        setLoggedInUser(data);
        sessionStorage.setItem(
          'user',
          JSON.stringify({
            role: data.role
          })
        );

        fetchUsers();
      } catch (err) {
        console.error(err);
        navigate('/');
      }
    };

    checkAuth();
  }, [navigate, fetchUsers]);

  const handleRegistration = async (e) => {
    e.preventDefault();

    setRegError('');
    setRegMessage('');

    try {
      const response = await fetch(`${API_BASE}/api/admin/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ username, password, role })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Registration failed.');
      }

      setRegMessage(`User ${username} registered successfully.`);
      setUsername('');
      setPassword('');
      setRole('factory');
      fetchUsers();
    } catch (err) {
      console.error(err);
      setRegError(err.message || 'An error occurred during registration.');
    }
  };

  const handleDeleteUser = async (userId) => {
    const confirmed = window.confirm('Are you sure you want to delete this user?');
    if (!confirmed) return;

    setDelMessage('');
    setDelError('');

    try {
      const response = await fetch(`${API_BASE}/api/admin/users/${userId}`, {
        method: 'DELETE',
        credentials: 'include'
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to delete user.');
      }

      setDelMessage(data.message || 'User deleted successfully.');
      fetchUsers();
    } catch (err) {
      console.error(err);
      setDelError(err.message || 'An error occurred while deleting the user.');
    }
  };

  return (
    <div className="admin-center">
      <header className="dashboard-header">
        <nav>
          <ul className="header-nav">
            <li><Link to="/team-lead">Team Lead Dashboard</Link></li>
            <li><a href="/team-lead#manage-chemicals">Manage Chemicals</a></li>
            <li><Link to="/admin">Admin Center</Link></li>
          </ul>
        </nav>
      </header>

      <h1>Admin Center</h1>
      <Logout />

      <form onSubmit={handleRegistration}>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <select value={role} onChange={(e) => setRole(e.target.value)}>
          <option value="factory">Factory</option>
          <option value="team_lead">Team Lead</option>
        </select>

        <Button type="submit">Register User</Button>
      </form>

      {regMessage && <p className="success">{regMessage}</p>}
      {regError && <p className="error">{regError}</p>}

      <hr />

      <h2>Current Users</h2>

      {delMessage && <p className="success">{delMessage}</p>}
      {delError && <p className="error">{delError}</p>}

      <ul className="user-list">
        {users.map((user) => (
          <li key={user.id}>
            <span>{user.username} - {user.role}</span>
            <Button onClick={() => handleDeleteUser(user.id)}>
              Delete User
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AdminCenter;